/**
 * F61 (A2/A3) — admin page KPI tiles client.
 *
 *   GET /admin/page-kpis?page=<page>[&fresh=1] → get  { data: AdminPageKpis<page> }
 *
 * Replaces the pages' audited `perPage=1` list reads (open games, game reports,
 * tournaments, skill disputes, clubs, dashboard). The vitest config aliases this
 * module to `pageKpis.fixture`; the real request shape is pinned by
 * test/client-contracts-page-kpis.test.ts.
 */
import type { AdminPageKpiPage, AdminPageKpis } from '@bravemove/types';
import { adminFetch, buildQuery } from '../auth/apiClient';

export interface PageKpisOpts {
  /** Skip the API's 15 s cache — used right after an admin action. */
  readonly fresh?: boolean;
}

export const adminPageKpisApi = {
  get: async <P extends AdminPageKpiPage>(
    page: P,
    opts: PageKpisOpts = {},
  ): Promise<AdminPageKpis<P>> => {
    const body = await adminFetch<{ readonly data: AdminPageKpis<P> }>(
      `/admin/page-kpis${buildQuery({ page, fresh: opts.fresh ? '1' : undefined })}`,
    );
    return body.data;
  },
};
